define(['components/utilities/utilities'], function (utils) {
	'use strict';

	/**
	 * Jump to top
	 * A plugin that displays the "jumptotop"-link when the user has scrolled down a bit.
	 * @exports jumptotop
	 */
	var jumptotop = {

		/** Top offset from which the link will be visible. */
		offsetTop: 135,


		/**
		 * The initialization function for this module.
		 * @param {Object} el - A DOM node.
		 * @public
		 */
		init: function () {
			var el = document.getElementById('jump-to-top');

			if (el !== null) {
				this._initJumptotop(el);
				this._initEvents(el);
			}
		},


		/**
		 * Initiates the jump to top visibility toggle.
		 * @param {Object} el - A DOM node.
		 * @private
		 */
		_initJumptotop: function (el) {
			var that = this,
				elIsVisible = false;

			window.onscroll = _decideVisibility;

			function _decideVisibility () {
				var scrollTop = window.pageYOffset;
				if (scrollTop > that.offsetTop && !elIsVisible) {
					utils.removeClass(el, 'is-hidden');
					elIsVisible = true;
				}
				else if (scrollTop < that.offsetTop && elIsVisible) {
					utils.addClass(el, 'is-hidden');
					elIsVisible = false;
				}
			}
		},


		/**
		 * Init click event, that scrolls to 1px from top (so we don't get an adressbar on_decide iPhone).
		 * @param {Object} el - A DOM node.
		 * @private
		 */
		_initEvents: function (el) {
			utils.addEventListener(el, 'click', function (event) {
				if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

				utils.scrollToY(1, 1500, 'easeInOutQuint');
			});
		}
	};


	return jumptotop;
});


//////////////////
// WEBPACK FOOTER
// ./components/jumptotop/jumptotop.js
// module id = 2
// module chunks = 0